export const toExplicitBoolean = (value: unknown): boolean | null => {
  if (value === true || value === 1 || value === '1') return true
  if (value === false || value === 0 || value === '0') return false
  return null
}

export const getLessonPaymentState = (isPaid: unknown, hasEnoughBalance: unknown) => {
  const paid = toExplicitBoolean(isPaid)
  const enough = toExplicitBoolean(hasEnoughBalance)
  if (paid === true) return { covered: true, title: 'Занятие оплачено' }
  if (enough === true) {
    return { covered: true, title: 'На балансе достаточно средств, чтобы оплатить занятие' }
  }
  if (paid === false || enough === false) {
    return { covered: false, title: 'Неоплаченное занятие' }
  }
  return { covered: null, title: 'Нет данных об оплате занятия' }
}
